import {
    DataSource, DataSourceMode, DropdownItem, Layout, LookupModelSelectionEvent, SaveButton, SlideoutDecorator, Textbox
} from "@mcleod/components";
import { ModelRow, UserSettings } from "@mcleod/core";
import { AutogenLayoutEquipmentIssued } from "./autogen/AutogenLayoutEquipmentIssued";
import { EquipmentItem } from "./EquipmentGroupValidation";


interface EquipmentIssuedProps {
    EquipmentItemType: EquipmentItem;
    Title: string;
    onSave: (newRow: ModelRow) => void;
}

export class EquipmentIssued extends AutogenLayoutEquipmentIssued {

    override onLoad() {
        this.textboxEquipmentTypeId.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => this.equipmentTypeSelected(event));
    }

    private equipmentTypeSelected(event: LookupModelSelectionEvent) {
        if (event.hasSelection() === true) {
            const selectedRow = event.selection;
            this.activeRow.setValues({
                "equipment_type_id": selectedRow.get("id")
            });
            this.activeRow.setLookupModelData("equipment_type_id", { "id": selectedRow.get("id"), "descr": selectedRow.get("descr") });
            this.mainDataSource.displayDataInBoundComponents();
        }
    }

    initialize(textbox: Textbox, type: EquipmentItem, dataSource: DataSource) {
        this.sourceEquipmentIssued = dataSource;
        let lookupModel: string;
        let lookupModelLayout: string;
        switch(type) {
            case EquipmentItem.TRACTOR: {
                lookupModel = "lme/dispatch/match-tractor-item-type";
                lookupModelLayout = "lme/dispatch/EquipmentTypeAppliesToTractorItem";
                break;
            }
            case EquipmentItem.TRAILER: {
                lookupModel = "lme/dispatch/match-trailer-item-type";
                lookupModelLayout = "lme/dispatch/EquipmentTypeAppliesToTrailerItem";
                break;
            }
            case EquipmentItem.DRIVER: {
                lookupModel = "lme/dispatch/match-driver-item-type";
                lookupModelLayout = "lme/dispatch/EquipmentTypeAppliesToDriverItem";
                break;
            }
            default: {
                lookupModel = "";
                lookupModelLayout = "";
                break;
            }
        }
        textbox.lookupModel = lookupModel;
        textbox.lookupModelLayout = lookupModelLayout;
    }

    static showSlideout(props: EquipmentIssuedProps) {
        const layout = Layout.getLayout("lme/dispatch/asset/EquipmentIssued") as EquipmentIssued;
        const decorator = new SlideoutDecorator({
                layout: layout,
                width: window.innerWidth * .45,
                title: props.Title,
                fillVerticalSpace: true,
                overlayProps: { closeOnClickOff: false, greyedBackground: true },
                layoutLoadListeners: async (event) => {
                layout.mainDataSource.mode = DataSourceMode.ADD
                layout.mainDataSource.rowIndex = 0;
                layout.initialize(layout.textboxEquipmentTypeId, props.EquipmentItemType, layout.sourceEquipmentIssued);
                // layout.setCaption();
            },
            doAfterSlideIn: (decorator: SlideoutDecorator) => {
                layout.textboxStatus.text = "Issued";
                layout.textboxStatus.dataSource.activeRow.set("status", "I");
                const userId = UserSettings.getUserId();
                const userName = UserSettings.getUserName();
                layout.textboxIssuedUserId.selectedItem = new DropdownItem(userId, userName);
                layout.textboxIssuedUserId.dataSource.activeRow.set("issued_user_id", userId);
            },
            onClose: (cancelled: boolean) => {
                decorator.slideOut();
            },
            addlComponents: SaveButton.create({
                id: "handReqSaveButton",
                caption: "Save & Close",
                backgroundColor: "primary",
                color: "primary.reverse",
                minWidth: 128,
                borderWidth: 0,
                rowBreak: false,
                allowSaveAndAdd: false
            })
        });

    }


    async populateTable(enabled?: boolean, hdrRows?: ModelRow<any>[], id?: string): Promise<void> {
        if (enabled != null)
            this.enabled = enabled;
        this.sourceEquipmentIssued.mode = DataSourceMode.UPDATE;
        return Promise.resolve();
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxReceivedUserId. */
    textboxReceivedUserIdBeforeLookupModelSearch(event) {
        event.filter.is_active = "Y";
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxIssuedUserId. */
    textboxIssuedUserIdBeforeLookupModelSearch(event) {
        event.filter.is_active = 'Y';
    }

}
